import * as actions from '../../actions/actionTypes';

const initialState = false;

export default function manualResultFetching(state = initialState, action) {
  switch (action.type) {
    case actions.SET_MANUAL_RESULT_FETCHING:
      return true;
    case actions.SET_MANUAL_RESULT:
      return false;
    default:
      return state;
  }
}
